import { useUserStore } from "~/stores/usuario_store";

export default defineNuxtRouteMiddleware(async (to, from) => {
  const userStore = useUserStore();
  if (process.server) return;

  let path = to.path.split("/")[1];
  if (path === "error") return;
  if (path === "login") return;

  if (!userStore.isAuthenticated) {
    return navigateTo("/login", { external: true });
  }

  return null;
});
